const CHUNK_LOAD_ERROR_NAME = "ChunkLoadError";

// Each browser and bundler words a stale-chunk failure differently. WebKit has two: a plain failed
// import, and a MIME error when the CDN answers a deleted chunk with the SPA's index.html.
const CHUNK_LOAD_ERROR_MESSAGES = [
  "dynamically imported module",
  "Importing a module script failed",
  "is not a valid JavaScript MIME type",
  "Loading chunk",
  "Loading CSS chunk",
  "Unable to preload",
] as const;

export const isChunkLoadError = (error: unknown): error is Error =>
  error instanceof Error
  && (
    error.name === CHUNK_LOAD_ERROR_NAME
    || CHUNK_LOAD_ERROR_MESSAGES.some((message) => error.message.includes(message))
  );
